import { createFileRoute } from '@tanstack/react-router';

import { GoalsPage } from '@/components/goals/goals-page';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/goals/')({
  loader: () => loadNamespaces('goals', 'settings'),
  staticData: {
    title: 'route.goals.title',
  },
  component: GoalsPage,
});
